export const Unit = {
    "ID": "",
    "Client_Income": "$",
    "Credit_Amount": "$",
    "Loan_Annuity": "$",
    "Client_Gender": "",
    "Client_Income_Type": "",
    "Client_Country": "",
    "symboling": "risk",
    "normalized-losses": "",
    "make": "",
    "num-of-doors": "",
    "body-style": "",
    "drive-wheels": "",
    "engine-location": "",
    "wheel-base": "mm",
    "length": "feet",
    "width": "feet",
    "height": "feet",
    "curb-weight": "pounds",
    "engine-type": "",
    "num-of-cylinders": "",
    "engine-size": "cubic inches",
    "fuel-system": "",
    "bore": "inches",
    "stroke": "inches",
    "compression-ratio": "",
    "horsepower": "HP",
    "peak-rpm": "rpm",
    "city-mpg": "mpg",
    "highway-mpg": "mpg",
    "price": "$",
    "city-L/100km": "L/100km",
    "horsepower-binned": "",
    "diesel": "",
    "gas": "",
}